import {ArrowLeft, Mail, FileText, CheckCircle2, Trash2} from 'lucide-react';
import {Ticket} from '../../types';
import {Btn, StatusBadge} from '../Shared';
import {Dialog, DialogContent, DialogTitle, DialogDescription} from '../ui/dialog';

type HeaderProps = {ticket: Ticket; onBack: () => void; onDelete: () => void};
const priorityClasses: Record<string, string> = {Urgent: 'urgent', High: 'priority'};

export const TicketHeader = ({ticket, onBack, onDelete}: HeaderProps) => {
  const gmail = ticket.source === 'gmail';
  const SourceIcon = gmail ? Mail : FileText;
  const priorityClass = priorityClasses[ticket.priority] || '';
  return <>
    <div className="detail-overline">
      <button className="mobile-back" data-testid="ticket-back" aria-label="Back to inbox" onClick={onBack}><ArrowLeft size={17}/></button>
      <span className="ticket-number" data-testid="ticket-number">TKT-{ticket.number}</span>
      <span className="overline-separator"/><SourceIcon size={11}/>
      <span data-testid="ticket-source">{gmail ? 'Gmail' : 'Manual intake'}</span>
      {ticket.is_sample && <span data-testid="ticket-sample-label">· Sample</span>}
      <div className="detail-controls"><button data-testid="ticket-delete" className="icon-button" title="Delete ticket" aria-label="Delete ticket" onClick={onDelete}><Trash2 size={13}/></button></div>
    </div>
    {ticket.status === 'resolved' && <div className="resolved-banner" data-testid="ticket-resolved-banner"><CheckCircle2 size={14}/>This conversation is resolved.</div>}
    <h2 className="ticket-title" data-testid="ticket-title">{ticket.subject}</h2>
    <div className="detail-tags">
      <span className={`detail-tag ${priorityClass}`} data-testid="ticket-priority"><i className={`priority-dot ${ticket.priority}`}/>{ticket.priority} priority</span>
      <span className="detail-tag" data-testid="ticket-category">{ticket.category}</span>
      <StatusBadge status={ticket.status} id="ticket-status"/>
    </div>
  </>;
};

type DeleteProps = {open: boolean; onOpenChange: (open: boolean) => void; onConfirm: () => Promise<void>};
export const TicketDeleteDialog = ({open, onOpenChange, onConfirm}: DeleteProps) => <Dialog open={open} onOpenChange={onOpenChange}>
  <DialogContent className="app-modal" data-testid="delete-ticket-modal">
    <DialogTitle data-testid="delete-ticket-heading">Delete this ticket?</DialogTitle>
    <DialogDescription data-description="true" data-testid="delete-ticket-description">The message, draft, and feedback will be permanently removed.</DialogDescription>
    <div className="form-footer">
      <Btn onClick={() => onOpenChange(false)} data-testid="delete-ticket-cancel">Cancel</Btn>
      <Btn className="danger-button" onClick={onConfirm} data-testid="delete-ticket-confirm">Delete ticket</Btn>
    </div>
  </DialogContent>
</Dialog>;